import { trpc } from "@carrot/bff-client"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import type { PhotoIdImage } from "./PhotoIdUpload"

export const photoIdOnFileQueryKey = ["telemedicine", "getPhotoIdOnFile"]

export function usePhotoIdOnFile({ enabled, refreshOnMount = false }: { enabled: boolean; refreshOnMount?: boolean }) {
  return useQuery({
    queryKey: photoIdOnFileQueryKey,
    queryFn: () => trpc.telemedicine.getPhotoIdOnFile.query(),
    enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: refreshOnMount ? "always" : true,
    staleTime: Infinity
  })
}

export function useUploadPhotoId(onSuccess?: () => void) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (images: { front: PhotoIdImage; back: PhotoIdImage }) =>
      trpc.telemedicine.uploadIdDocuments.mutate(images),
    onSuccess: () => {
      // Shared by booking and the appointment's Complete forms path.
      queryClient.setQueryData(photoIdOnFileQueryKey, { onFile: true })
      onSuccess?.()
    }
  })
}
